import { UseQueryOptions } from 'react-query'
import { CaptionGenerationResponse, useAICaptionGeneration } from './useAICaptionGeneration'

interface Props {
  id?: string
}

interface Options extends Omit<UseQueryOptions<CaptionGenerationResponse>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollAICaptionGeneration = ({ id }: Props, options?: Options) => {
  return useAICaptionGeneration(
    { id },
    {
      refetchInterval: (data) => {
        if (data?.status !== undefined && ['done', 'failed'].includes(data.status)) {
          return false
        }

        return options?.intervalMs || 500
      },
      ...options,
    },
  )
}
